import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from '../_commonComponents/modal/modal.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { ToastrModule } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { BarChartComponent } from '../_commonComponents/bar-chart/bar-chart.component';
import { ShortCurrencyPipe } from '../core/pipes/short-currency.pipe';
import { ColorNamePipe } from '../core/pipes/color-name.pipe';
import { AnalyticCardComponent } from '../_commonComponents/analytic-card/analytic-card.component';
import { SmallBarChartComponent } from '../_commonComponents/small-bar-chart/small-bar-chart.component';
import { PieChartComponent } from '../_commonComponents/pie-chart/pie-chart.component';
import { ChartTableComponent } from '../_commonComponents/chart-table/chart-table.component';
import { NoDataComponent } from '../_commonComponents/no-data/no-data.component';
import { AppLoaderComponent } from '../_commonComponents/app-loader/app-loader.component';
import { ExtractPricePipe } from '../core/pipes/extract-price.pipe';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { EChartsComponent } from '../_commonComponents/e-charts/e-charts.component';
import { ProfileIcon } from '../_commonComponents/icons/profile-icon.component';
import { BagIcon } from '../_commonComponents/icons/bag-icon.component';
import { whishlistIcon } from '../_commonComponents/icons/whishlist-icon.component';
import { SearchIcon } from '../_commonComponents/icons/search-icon.component';
import { TooltipModule } from '../module/tooltip/tooltip.module';
import { SkeletonLoaderComponent } from '../_commonComponents/skeleton-loader/skeleton-loader.component';
import { WordTruncatePipe } from '../core/pipes/word-truncate.pipe';
import { CapitalizePipe } from '../core/pipes/capitalize.pipe';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { NoWheelDirective } from './directives/no-wheel.directive';
import { HasPermissionPipe } from './pipes/has-permission.pipe';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { OrderStatusPipe } from '../core/pipes/order-status.pipe';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { LocaleNumberPipe } from '../core/pipes/locale-number.pipe';
import { LocaleCurrencyPipe } from '../core/pipes/locale-currency.pipe';
import { InventoryFiltersV2Component } from '../pages/product/inventory/components/inventory-filters/inventory-filters.component';
import { GiftOrderBadgeComponent } from './components/gift-order-badge/gift-order-badge.component';
import { CreatorLinkBadgeComponent } from './components/creator-link-badge/creator-link-badge.component';
@NgModule({
  declarations: [
    ModalComponent,
    BarChartComponent,
    EChartsComponent,
    ProfileIcon,
    BagIcon,
    SearchIcon,
    whishlistIcon,
    ShortCurrencyPipe,
    ColorNamePipe,
    ExtractPricePipe,
    AnalyticCardComponent,
    SmallBarChartComponent,
    PieChartComponent,
    ChartTableComponent,
    WordTruncatePipe,
    CapitalizePipe,
    RichTextEditorComponent,
    OrderStatusPipe,
    DateRangePickerComponent,
    LocaleNumberPipe,
    LocaleCurrencyPipe,
    InventoryFiltersV2Component,
    GiftOrderBadgeComponent,
    CreatorLinkBadgeComponent
  ],
  imports: [
    TooltipModule,
    CommonModule,
    NgSelectModule,
    FormsModule,
    NoDataComponent,
    AppLoaderComponent,
    SkeletonLoaderComponent,
    TranslateModule,
    NgxPaginationModule,
    FlatpickrModule.forRoot(),
    ToastrModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    AngularEditorModule,
    HasPermissionDirective,
    HasPermissionPipe,
    NoWheelDirective
  ],
  exports: [
    TooltipModule,
    ModalComponent,
    NgSelectModule,
    FormsModule,
    NoDataComponent,
    AppLoaderComponent,
    SkeletonLoaderComponent,
    FlatpickrModule,
    ToastrModule,
    NgxPaginationModule,
    BarChartComponent,
    EChartsComponent,
    ProfileIcon,
    BagIcon,
    SearchIcon,
    whishlistIcon,
    ShortCurrencyPipe,
    ColorNamePipe,
    ExtractPricePipe,
    AnalyticCardComponent,
    SmallBarChartComponent,
    ChartTableComponent,
    WordTruncatePipe,
    CapitalizePipe,
    OrderStatusPipe,
    LocaleNumberPipe,
    LocaleCurrencyPipe,
    TranslateModule,
    NgxDaterangepickerMd,
    AngularEditorModule,
    HasPermissionDirective,
    HasPermissionPipe,
    RichTextEditorComponent,
    DateRangePickerComponent,
    NoWheelDirective,
    InventoryFiltersV2Component,
    GiftOrderBadgeComponent,
    CreatorLinkBadgeComponent
  ],
  providers: [TranslatePipe]
})
export class SharedModule {}
